var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var styles = require('style.less');

var Router = require('./Router');

var $ = require("jquery");

$.fn.setAttrIf = function (cond, attr, val) {
    if (cond)
        return this.attr(attr, val);
    else return this.removeAttr(attr);
};



app.staticPath = '/static/';

SVGElement.prototype.hasClass = function (className) {
    return new RegExp('(\\s|^)' + className + '(\\s|$)').test(this.getAttribute('class'));
};


SVGElement.prototype.addClass = function (className) {
    if (!this.hasClass(className)) {
        this.setAttribute('class', this.getAttribute('class') + ' ' + className);
    }
};


SVGElement.prototype.removeClass = function (className) {
    var removedClass = this.getAttribute('class').replace(new RegExp('(\\s|^)' + className + '(\\s|$)', 'g'), '$2');
    if (this.hasClass(className)) {
        this.setAttribute('class', removedClass);
    }
};


SVGElement.prototype.toggleClass = function (className) {
    if (this.hasClass(className)) {
        this.removeClass(className);
    } else {
        this.addClass(className);
    }
};


window.app.isPhoneLayout = function() {
    return window.innerWidth < 768;
};


//https://codepen.io/shshaw/pen/yyOaqW
(function(Modernizr) {

    // Here are all the values we will test. If you want to use just one or two, comment out the lines of test you don't need.
    var tests = [{
            name: 'svg',
            value: 'url(#test)'
        }, // False positive in IE, supports SVG clip-path, but not on HTML element
        {
            name: 'inset',
            value: 'inset(10px 20px 30px 40px)'
        }, {
            name: 'circle',
            value: 'circle(60px at center)'
        }, {
            name: 'ellipse',
            value: 'ellipse(50% 50% at 50% 50%)'
        }, {
            name: 'polygon',
            value: 'polygon(50% 0%, 0% 100%, 100% 100%)'
        }
    ];

    var t = 0,
        name, value, prop;

    for (; t < tests.length; t++) {
        name = tests[t].name;
        value = tests[t].value;
        Modernizr.addTest('cssclippath' + name, function() {
            // Try using window.CSS.supports
            if ('CSS' in window && 'supports' in window.CSS) {
                for (var i = 0; i < Modernizr._prefixes.length; i++) {
                    prop = Modernizr._prefixes[i] + 'clip-path'

                    if (window.CSS.supports(prop, value)) {
                        return true;
                    }
                }
                return false;
            }
            // Otherwise, use Modernizr.testStyles and examine the property manually
            return Modernizr.testStyles('#modernizr { ' + Modernizr._prefixes.join('clip-path:' + value + '; ') + ' }', function(elem, rule) {
                var style = getComputedStyle(elem),
                    clip = style.clipPath;

                if (!clip || clip == "none") {
                    clip = false;

                    if (Modernizr._domPrefixes) {
                        for (var i = 0; i < Modernizr._domPrefixes.length; i++) {
                            test = Modernizr._domPrefixes[i] + 'ClipPath';
                            if (style[test] && style[test] !== "none") {
                                clip = true;
                                break;
                            }
                        }
                    }
                }

                return Modernizr.testProp('clipPath') && clip;
            });
        });
    }
})(Modernizr);


window.app.queryUrlGetParam = function (variable, url) {
    if (!url) {
        return '';
    }

    try {
        var queryParts = url.split('?');
        var query = queryParts[queryParts.length - 1];

        if (!query) {
            return '';
        }
        var v = query.split('&');
        for (var i = 0; i < v.length; i++ ) {
            var p = v[i].split('=');
            if (p[0] == variable) {
                if (p.length > 1) {
                    return decodeURIComponent(p[1]);
                } else {
                    return ''; //if variable for empty param, without value
                }
            }
        }
    } catch (e) {
        console.log(e);
    }
}


window.app.waitForTransitionEnd = function ($obj, property, cb, safeTimeout) {

    var transEndEventNames = {
        'transition'       : 'transitionend',
        'WebkitTransition' : 'webkitTransitionEnd',
        'MozTransition'    : 'transitionend',
        'OTransition'      : 'oTransitionEnd',
        'msTransition'     : 'MSTransitionEnd'
    };

    var getTransitionEndName = function () {
        if (!window.getComputedStyle || !document.documentElement) {
            return 'transitionend';
        }

        var styles = window.getComputedStyle(document.documentElement, '');

        for (var i in transEndEventNames) {
            if (styles[i] != undefined) {
                return transEndEventNames[i];
            }
        }

        return 'transitionend';
    };

    var transEndEventName = getTransitionEndName();

    var transitionEndCallback = function (e) {

        if (e) {
            var prop = e.originalEvent.propertyName.toLowerCase();
            if (!$(e.target).is($obj)) return;
            if (prop.indexOf(property) == -1) return;
        }

        $obj.off(transEndEventName, transitionEndCallback);

        clearTimeout(transitionSafeTimeout);

        cb();
    };

    var resetAllHandlers = function () {
        $obj.off(transEndEventName, transitionEndCallback);

        clearTimeout(transitionSafeTimeout);
    };

    $obj.on(transEndEventName, transitionEndCallback);

    var transitionSafeTimeout = setTimeout(transitionEndCallback, safeTimeout == undefined ? this.getTransitionDuration($obj[0], property) + 100 : safeTimeout);

    return resetAllHandlers;
};

$.fn.flashClass = function(className, delay) {
    var self = this,
        timeout;
    this.addClass(className);
    clearTimeout(this.data('timeout'));
    timeout = setTimeout(function() {
        if(typeof self == 'object' && self.length)  {
            self.removeClass(className);
            self.data('timeout', null);
        }
    }, delay);
    this.data('timeout', timeout);
    return this;
};

window.app.easingFunctions = function(st, ed, per, easing) {
    var functions = {
        //simple linear tweening - no easing, no acceleration
        linearTween: function (t, b, c, d) {
            return c*t/d + b;
        },

        // quadratic easing in - accelerating from zero velocity
        easeInQuad: function (t, b, c, d) {
            t /= d;
            return c*t*t + b;
        },

        // quadratic easing out - decelerating to zero velocity
        easeOutQuad: function (t, b, c, d) {
            t /= d;
            return -c * t*(t-2) + b;
        },

        // quadratic easing in/out - acceleration until halfway, then deceleration
        easeInOutQuad: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t + b;
            t--;
            return -c/2 * (t*(t-2) - 1) + b;
        },

        // cubic easing in - accelerating from zero velocity
        easeInCubic: function (t, b, c, d) {
            t /= d;
            return c*t*t*t + b;
        },

        // cubic easing out - decelerating to zero velocity
        easeOutCubic: function (t, b, c, d) {
            t /= d;
            t--;
            return c*(t*t*t + 1) + b;
        },

        // cubic easing in/out - acceleration until halfway, then deceleration
        easeInOutCubic: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t*t + b;
            t -= 2;
            return c/2*(t*t*t + 2) + b;
        },

        // quartic easing in - accelerating from zero velocity
        easeInQuart: function (t, b, c, d) {
            t /= d;
            return c*t*t*t*t + b;
        },

        // quartic easing out - decelerating to zero velocity
        easeOutQuart: function (t, b, c, d) {
            t /= d;
            t--;
            return -c * (t*t*t*t - 1) + b;
        },

        // quartic easing in/out - acceleration until halfway, then deceleration
        easeInOutQuart: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t*t*t + b;
            t -= 2;
            return -c/2 * (t*t*t*t - 2) + b;
        },

        // quintic easing in - accelerating from zero velocity
        easeInQuint: function (t, b, c, d) {
            t /= d;
            return c*t*t*t*t*t + b;
        },

        // quintic easing out - decelerating to zero velocity
        easeOutQuint: function (t, b, c, d) {
            t /= d;
            t--;
            return c*(t*t*t*t*t + 1) + b;
        },

        // quintic easing in/out - acceleration until halfway, then deceleration
        easeInOutQuint: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2*t*t*t*t*t + b;
            t -= 2;
            return c/2*(t*t*t*t*t + 2) + b;
        },

        // sinusoidal easing in - accelerating from zero velocity
        easeInSine: function (t, b, c, d) {
            return -c * Math.cos(t/d * (Math.PI/2)) + c + b;
        },

        // sinusoidal easing out - decelerating to zero velocity
        easeOutSine: function (t, b, c, d) {
            return c * Math.sin(t/d * (Math.PI/2)) + b;
        },

        // sinusoidal easing in/out - accelerating until halfway, then decelerating
        easeInOutSine: function (t, b, c, d) {
            return -c/2 * (Math.cos(Math.PI*t/d) - 1) + b;
        },

        // exponential easing in - accelerating from zero velocity
        easeInExpo: function (t, b, c, d) {
            return c * Math.pow( 2, 10 * (t/d - 1) ) + b;
        },

        // exponential easing out - decelerating to zero velocity
        easeOutExpo: function (t, b, c, d) {
            return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
        },

        // exponential easing in/out - accelerating until halfway, then decelerating
        easeInOutExpo: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
            t--;
            return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
        },

        // circular easing in - accelerating from zero velocity
        easeInCirc: function (t, b, c, d) {
            t /= d;
            return -c * (Math.sqrt(1 - t*t) - 1) + b;
        },

        // circular easing out - decelerating to zero velocity
        easeOutCirc: function (t, b, c, d) {
            t /= d;
            t--;
            return c * Math.sqrt(1 - t*t) + b;
        },

        // circular easing in/out - acceleration until halfway, then deceleration
        easeInOutCirc: function (t, b, c, d) {
            t /= d/2;
            if (t < 1) return -c/2 * (Math.sqrt(1 - t*t) - 1) + b;
            t -= 2;
            return c/2 * (Math.sqrt(1 - t*t) + 1) + b;
        }
    };

    return functions[easing](per, st, ed - st, 1);
};


Modernizr.addTest('safari', function() {
   return navigator.userAgent.indexOf('Safari') != -1 && (navigator.userAgent.indexOf('Mac') != -1 || navigator.userAgent.indexOf('Windows')) && navigator.userAgent.indexOf('Chrome') == -1
});

Modernizr.addTest('firefox', function(){
    return window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
});

Modernizr.addTest('ieAny', function(){
    var ieLTE10 = ( !!window.ActiveXObject && +( /msie\s(\d+)/i.exec( navigator.userAgent )[1] ) ) || NaN;
    var ie11 = navigator.userAgent.indexOf('Trident/') != -1 && (navigator.userAgent.indexOf('rv:') != -1 || navigator.appName.indexOf('Netscape') != -1);

    return ieLTE10 || ie11;
});

Modernizr.addTest('ieOld', function(){
    var ieVersion = ( !!window.ActiveXObject && +( /msie\s(\d+)/i.exec( navigator.userAgent )[1] ) ) || NaN;

    return (ieVersion - 0) <= 8;
});

Modernizr.addTest('ie9', function(){
    var ieVersion = ( !!window.ActiveXObject && +( /msie\s(\d+)/i.exec( navigator.userAgent )[1] ) ) || NaN;

    return (ieVersion - 0) == 9;
});

Modernizr.addTest('ie10', function(){
    var ieVersion = ( !!window.ActiveXObject && +( /msie\s(\d+)/i.exec( navigator.userAgent )[1] ) ) || NaN;

    return (ieVersion - 0) == 10;
});

Modernizr.addTest('ie11', function(){
    return navigator.userAgent.indexOf('Trident/') != -1 && (navigator.userAgent.indexOf('rv:') != -1 || navigator.appName.indexOf('Netscape') != -1);
});

Modernizr.addTest('edge', function(){
    return /Edge\/\d./i.test(navigator.userAgent);
});

Modernizr.addTest('webgl', function(){
    return detectWebGL == 1;
});


function detectWebGL() {
    // Check for the WebGL rendering context
    if ( !! window.WebGLRenderingContext) {
        var canvas = document.createElement("canvas"),
            names = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
            context = false;

        for (var i in names) {
            try {
                context = canvas.getContext(names[i]);
                if (context && typeof context.getParameter === "function") {
                    // WebGL is enabled.
                    return 1;
                }
            } catch (e) {}
        }

        // WebGL is supported, but disabled.
        return 0;
    }

    // WebGL not supported.
    return -1;
};


Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
           isFinite(value) &&
           Math.floor(value) === value;
};

// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame']
                                   || window[vendors[x]+'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());


$('html')
    .addClass(app.settings.isDesktop ? "isDesktop" : "isNotDesktop")
    .addClass(app.settings.isTablet ? "isTablet" : "isNotTablet")
    .addClass(app.settings.isPhone ? "isPhone" : "isNotPhone");

Modernizr.addTest('macos', function(){
    return window.navigator.userAgent.indexOf('Mac') != -1;
});

window.app.vent = _.extend({}, Backbone.Events);

window.app.els = {
    $window: $(window),
    $body: $('body')
};

app.router = new Router();

app.router.start();



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/App.js
 ** module id = 0
 ** module chunks = 0
 **/